import { connect } from 'react-redux';

import BaseComponent from '../../components/BaseComponent';
import { sendcvConfig } from '../../entity/clinets/sendcvConfig';

class SendCv extends BaseComponent {
  constructor(props) {
    super(props);
    this.config = { ...sendcvConfig };
    this.getResponse();
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(SendCv);
